import { oc } from "@orpc/contract";
import {
  GetColumnConfigInputSchema,
  GetColumnConfigResponseSchema,
  UpsertColumnConfigInputSchema,
  UpsertColumnConfigResponseSchema,
} from "./user-table-column-configs.contract";

export const orgTableColumnConfigsContracts = {
  get: oc
    .input(GetColumnConfigInputSchema)
    .output(GetColumnConfigResponseSchema)
    .route({ method: "GET" }),
  upsert: oc
    .input(UpsertColumnConfigInputSchema)
    .output(UpsertColumnConfigResponseSchema)
    .route({ method: "POST" }),
} as const;
